module.exports = __webpack_public_path__ + "js/1.be01003b.worker.js"